import { inject, Service } from "@angular/core"
import { Observable } from "rxjs"
import { HttpClient } from "@angular/common/http"
import { Benefit, PagedBenefit, CreateBenefit, ModifyObject } from "../models"
import { environment } from "src/environments/environment"

export interface ColumnFilter {
    field: string
    value: string
    matchMode: string
}

export interface GetBenefitPagedParams {
    search?: string
    sortField?: string
    sortDescending?: boolean
    page: number
    pageSize: number
    columnFilters?: ColumnFilter[]
}

@Service({ autoProvided: false })
export class BenefitsService {
    private _http = inject(HttpClient)
    private _apiUrl = environment.apiBaseUrl + environment.endpointRoutes.benefits

    Get(): Observable<Benefit[]> {
        return this._http.get<Benefit[]>(this._apiUrl)
    }

    GetOne(masterId: string): Observable<Benefit> {
        return this._http.get<Benefit>(this.ByMasterIdUrl(masterId))
    }
    ByMasterIdUrl(masterId: string): string {
        return `${this._apiUrl}/${masterId}`
    }

    GetPaged(params: GetBenefitPagedParams): Observable<PagedBenefit> {
        const request = this.PagedRequest(params)
        return this._http.get<PagedBenefit>(request.url, { params: request.params })
    }
    PagedRequest(params: GetBenefitPagedParams): { url: string; params: Record<string, string> } {
        const httpParams: Record<string, string> = {
            page: params.page.toString(),
            pageSize: params.pageSize.toString(),
        }
        if (params.search) httpParams["search"] = params.search
        if (params.sortField) httpParams["sortField"] = params.sortField
        if (params.sortDescending !== undefined) httpParams["sortDescending"] = params.sortDescending.toString()
        if (params.columnFilters?.length) httpParams["columnFilters"] = JSON.stringify(params.columnFilters)

        return { url: this._apiUrl + "/paged", params: httpParams }
    }

    Create(createBenefit: CreateBenefit): Observable<Benefit> {
        return this._http.post<Benefit>(this._apiUrl, createBenefit)
    }

    Modify(masterId: string, data: ModifyObject): Observable<any> {
        return this._http.patch(this.ByMasterIdUrl(masterId), data)
    }

    Delete(masterId: string): Observable<string> {
        return this._http.delete<string>(this.ByMasterIdUrl(masterId))
    }
}
